__turbopack_context__.v({
  "answerSet": "CPolls-module__TWaooW__answerSet",
  "badgeFilled": "CPolls-module__TWaooW__badgeFilled",
  "button": "CPolls-module__TWaooW__button",
  "buttonSecondary": "CPolls-module__TWaooW__buttonSecondary",
  "choices": "CPolls-module__TWaooW__choices",
  "completed": "CPolls-module__TWaooW__completed",
  "empty": "CPolls-module__TWaooW__empty",
  "fieldError": "CPolls-module__TWaooW__fieldError",
  "guestFieldset": "CPolls-module__TWaooW__guestFieldset",
  "guestGrid": "CPolls-module__TWaooW__guestGrid",
  "guestLegend": "CPolls-module__TWaooW__guestLegend",
  "justification": "CPolls-module__TWaooW__justification",
  "list": "CPolls-module__TWaooW__list",
  "listItem": "CPolls-module__TWaooW__listItem",
  "listItemActions": "CPolls-module__TWaooW__listItemActions",
  "listItemBody": "CPolls-module__TWaooW__listItemBody",
  "listItemText": "CPolls-module__TWaooW__listItemText",
  "listItemTitle": "CPolls-module__TWaooW__listItemTitle",
  "poll": "CPolls-module__TWaooW__poll",
  "pollActions": "CPolls-module__TWaooW__pollActions",
  "pollText": "CPolls-module__TWaooW__pollText",
  "progress": "CPolls-module__TWaooW__progress",
  "question": "CPolls-module__TWaooW__question",
  "questionHead": "CPolls-module__TWaooW__questionHead",
  "questionNumber": "CPolls-module__TWaooW__questionNumber",
  "questionText": "CPolls-module__TWaooW__questionText",
  "questionTitle": "CPolls-module__TWaooW__questionTitle",
  "questionTitleWrap": "CPolls-module__TWaooW__questionTitleWrap",
  "questions": "CPolls-module__TWaooW__questions",
  "ranking": "CPolls-module__TWaooW__ranking",
  "rankingBtn": "CPolls-module__TWaooW__rankingBtn",
  "rankingButtons": "CPolls-module__TWaooW__rankingButtons",
  "rankingHint": "CPolls-module__TWaooW__rankingHint",
  "rankingItem": "CPolls-module__TWaooW__rankingItem",
  "rankingName": "CPolls-module__TWaooW__rankingName",
  "rankingOrder": "CPolls-module__TWaooW__rankingOrder",
  "remainQuestions": "CPolls-module__TWaooW__remainQuestions",
  "remainTime": "CPolls-module__TWaooW__remainTime",
  "score": "CPolls-module__TWaooW__score",
  "scoreQuestion": "CPolls-module__TWaooW__scoreQuestion",
  "scoreQuestionText": "CPolls-module__TWaooW__scoreQuestionText",
  "scoreQuestionTitle": "CPolls-module__TWaooW__scoreQuestionTitle",
  "srOnly": "CPolls-module__TWaooW__srOnly",
});
